import { render } from "./Catalog.vue?vue&type=template&id=33960f60&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=33960f60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33960f60"]])

export default __exports__